import React from 'react';
import { Box, Paper, Typography, Chip, Alert, CircularProgress } from '@mui/material';
import { usePartnerTenants } from '../context';

/**
 * Sidebar block for the partner Account Settings page showing the
 * partner's assigned dealerships.
 */
export const PartnerAccessSummary: React.FC = () => {
  const { tenants, loading } = usePartnerTenants();

  return (
    <Paper elevation={0} sx={{ p: 3, border: 1, borderColor: 'divider' }}>
      <Typography variant="h6" gutterBottom fontWeight={600}>
        Your Access
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        You have access to the following dealerships:
      </Typography>
      {loading ? (
        <CircularProgress size={20} />
      ) : tenants.length === 0 ? (
        <Alert severity="warning" sx={{ mt: 1 }}>
          No dealerships assigned. Contact your administrator.
        </Alert>
      ) : (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {tenants.map((tenant) => (
            <Chip key={tenant.id} label={tenant.name} size="small" />
          ))}
        </Box>
      )}
    </Paper>
  );
};

export default PartnerAccessSummary;
